export default {
}



// WEBPACK FOOTER //
// ./src/app/dweller/bike/index/resources/computed.js